import { updateIframeHeight } from '../updateIframeHeight';
export const atomIframe = () => updateIframeHeight('.atom__iframe');
